import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '@Services';
import { User } from '@Models';

export const roleGuard: CanActivateFn = () => {
  const _authService = inject(AuthService);
  const _router = inject(Router);

  const access_token = sessionStorage.getItem('access_token');
  const refresh_token = sessionStorage.getItem('refresh_token');

  let user: User | null = null;

  _authService.user$.subscribe((authUser) => {
    user = authUser;
  });

  if (user) {
    return true;
  } else if (access_token && refresh_token) {
    _authService.setSession(access_token, refresh_token);
    return true;
  } else {
    _router
      .navigate(['/login'], {
        queryParams: { error: 'Unauthorized' },
      })
      .catch((err) => {
        console.error(err);
      });
    return false;
  }
};
